/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveInstituto } from "../../services/InstitutoService";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  descripcion: "",
  email: "",
  domicilio: "",
  localidad: "",
  codigoPostal: "",
  idDepartamento: "",
  idProvincia: null,
  telefonoFijo: "",
  telefonoMovil: "",
  observaciones: "",
};

const nameItemText = "Instituto";
const itemGender = "M";
//
// ########################################################################### 
//
const InstitutoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [valueACDepartamentos, setValueACDepartamentos] = useState
    (
      itemCrud.departamento
    )
  const [inputValueACDepartamentos, setInputValueACDepartamentos] = useState("");

  const [valueACProvincias, setValueACProvincias] = useState
    (
      itemCrud.provincia
    )
  const [inputValueACProvincias, setInputValueACProvincias] = useState("");

  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);



  //
  // ################################################################################
  //
  useEffect(() => {
    loadDeparmentos();
    loadProvincias();

    if (actionCrud === "new") {
      setValueACDepartamentos(departamentos[0]);
      setValueACProvincias(provincias[0]);
      setItemCrudLocal(initialState);
    } else {
      setValueACDepartamentos(itemCrud.departamento);
      setValueACProvincias(itemCrud.provincia);
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el nombre del Instituto",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.descripcionCorta === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción corta del Instituto",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      descripcion: itemCrudLocal.descripcion,
      email: itemCrudLocal.email,
      telefono_fijo: itemCrudLocal.telefonoFijo,
      telefono_movil: itemCrudLocal.telefonoMovil,
      domicilio: itemCrudLocal.domicilio,
      localidad: itemCrudLocal.localidad,
      codigo_postal: itemCrudLocal.codigoPostal,
      id_departamento: valueACDepartamentos?.id ?? "",
      id_provincia: valueACProvincias?.id ?? "",
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveInstituto(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };

  //
  // ################################################################################
  //
  const loadDeparmentos = async () => {
    const response = await getCacheData("departamento");
    if (response.ok) {
      let _response = response.data.data;
      let _departamentos = [];
      _response.forEach((item) => {
        _departamentos.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setDepartamentos(_departamentos);
    } else {
      setDepartamentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProvincias = async () => {
    const response = await getCacheData("provincia");
    if (response.ok) {
      let _response = response.data.data;
      let _provincias = [];
      _response.forEach((item) => {
        _provincias.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setProvincias(_provincias);
    } else {
      setProvincias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Instituto"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="email"
                label="E-mail"
                variant="outlined"
                size="small"
                name="email"
                value={itemCrudLocal.email}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="domicilio"
                label="Domicilio"
                variant="outlined"
                size="small"
                name="domicilio"
                value={itemCrudLocal.domicilio}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={10}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="localidad"
                label="Localidad"
                variant="outlined"
                size="small"
                name="localidad"
                value={itemCrudLocal.localidad}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={2}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="codigoPostal"
                label="Código Postal"
                variant="outlined"
                size="small"
                name="codigoPostal"
                value={itemCrudLocal.codigoPostal}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                size="small"
                value={valueACDepartamentos}
                onChange={(event, newValue) => {
                  setValueACDepartamentos(newValue);
                }}
                inputValue={inputValueACDepartamentos}
                onInputChange={(event, newInputValue) => {
                  setInputValueACDepartamentos(newInputValue);
                }}
                id="Departamento"
                options={departamentos}
                renderInput={(params) => <TextField {...params} label="Departamento" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                size="small"
                value={valueACProvincias}
                onChange={(event, newValue) => {
                  setValueACProvincias(newValue);
                }}
                inputValue={inputValueACProvincias}
                onInputChange={(event, newInputValue) => {
                  setInputValueACProvincias(newInputValue);
                }}
                id="Provincia"
                options={provincias}
                renderInput={(params) => <TextField {...params} label="Provincia" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="telefonoFijo"
                label="Teléfono fijo"
                variant="outlined"
                size="small"
                name="telefonoFijo"
                value={itemCrudLocal.telefonoFijo}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="telefonoMovil"
                label="Teléfono movil"
                variant="outlined"
                size="small"
                name="telefonoMovil"
                value={itemCrudLocal.telefonoMovil}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1, backgroundColor: "warning" }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default InstitutoDialog;
